"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.range = void 0;

var _Typography = require("../elements/Typography");

/**
 * A helper func to create a range string out of two strings, by putting an endash between them.
 */
var range = function range(left, right) {
  return "".concat(left, " ").concat(_Typography.endash, " ").concat(right);
};

exports.range = range;
//# sourceMappingURL=typography.js.map